<template>
  <div>
    <div class="content-devx">
      <f7-row>
        <f7-col
          width="100"
          medium="50"
        >
          <DxForm
            id="costForm"
          >
            <DxGroupItem
              css-class="content-combo"
              :caption="$t('LeftPanel_subtitle_locationClimate')"
              :col-count="1"
            >
              <DxSimpleItem
                name="province"
                :data-field="$t('province')"
                editor-type="dxSelectBox"
                :editor-options="{
                  items: provinces,
                  displayExpr: 'value',
                  valueExpr: 'id',
                  value: province,
                  placeholder: $t('placeholder_province'),
                  searchEnabled: true,
                  onValueChanged: onChangeProvince,
                }"
              >
                <DxRequiredRule :message="$t('newUser.DxCostForm_Id_required')" />
              </DxSimpleItem>
              <DxSimpleItem
                :key="key"
                name="agroClimatic_station"
                :data-field="$t('agroClimatic_station')"
                editor-type="dxSelectBox"
                :editor-options="{
                  items: itemsClimate,
                  displayExpr: 'source',
                  valueExpr: 'idByType',
                  onValueChanged: onChangeStationClimate,
                  searchEnabled: true,
                  placeholder: $t('placeholder_station'),
                }"
              >
                <DxRequiredRule :message="$t('newUser.DxCostForm_Id_required')" />
              </DxSimpleItem>
              <DxSimpleItem
                name="Inicio"
                data-field="Inicio"
                editor-type="dxDateBox"
                :visible="selectedDataType === 'REAL_TIME'"
                :editor-options="{
                  value: initDate,
                  displayFormat: 'dd/MM/yyyy',
                  onValueChanged: onChangeInitDate,
                  max: maxInitDate,
                }"
              />
              <DxSimpleItem
                name="Fin"
                data-field="Fin"
                editor-type="dxDateBox"
                :visible="selectedDataType === 'REAL_TIME'"
                :editor-options="{
                  value: endDate,
                  displayFormat: 'dd/MM/yyyy',
                  onValueChanged: onChangeEndDate,
                  min: initDate ? initDate : null,
                  max: maxEndDate
                }"
              />
            </DxGroupItem>
          </DxForm>
        </f7-col>
        <f7-col
          width="100"
          medium="50"
        >
          <DxButton
            name="btnSignIn"
            :class="`boton-openAir ${selectedDataType === 'REAL_TIME' && (!initDate || !endDate) ? 'disabled': ''}`"
            style="color:#FFFFFF; border-radius: 4px; display: flex !important; justify-content: center !important;"
            @click="show"
          >
            {{ $t("show") }}
          </DxButton>
        </f7-col>
      </f7-row>
    </div>
    <div
      class="content-devx transparent headers-initial"
      style="margin: 0; padding: 1rem 0 !important;"
    >
      <div
        style="display: flex; justify-content: center !important; align-items: center; width: auto"
      >
        <DxScrollView
          scroll-by-content
          scroll-by-thumb
          direction="both"
        >
          <DxDataGrid
            :data-source="dataSource"
            :allow-column-reordering="true"
            :show-borders="true"
            :show-column-lines="true"
            :show-row-lines="false"
            :column-auto-width="true"
            :row-alternation-enabled="false"
            :word-wrap-enabled="true"
            no-data-text="Sin datos"
            @file-saving="onFileSaving"
          >
            <DxSelection
              mode="single"
            />
            <DxExport
              :enabled="true"
              :texts="{exportAll: 'Exportar',}"
              file-name="Base de Datos - LOCALIZACIÓN Y CLIMA - Aire Libre"
            />
            <DxPaging :page-size="10" />
            <DxPager
              :show-page-size-selector="true"
              :show-info="true"
              info-text="Página {0} de {1} ({2} días)"
              :allowed-page-sizes="['5', '10', '20', '30', '60']"
            />
            <DxHeaderFilter :visible="true" />
            <DxSearchPanel
              text=""
              :visible="true"
              :width="200"
              :placeholder="$t('Search_placeholder')"
            />
            <DxColumnFixing :enabled="true" />
            <DxColumn
              :visible="selectedDataTypeShow === 'REAL_TIME'"
              name="date"
              data-field="date"
              :caption="$t('dataBaseClimate.datagrid_date')"
              :allow-header-filtering="false"
              alignment="left"
              css-class="bold"
              data-type="date"
              format="dd/MM/yyyy"
            />
            <DxColumn
              :visible="selectedDataTypeShow === 'MEAN_YEAR'"
              name="yearoftheday"
              data-field="yearoftheday"
              :caption="$t('dataBaseClimate.datagrid_yearOfDay')"
              :allow-header-filtering="false"
              alignment="left"
              css-class="bold"
            />
            <DxColumn
              data-field="tmax"
              :caption="$t('dataBaseClimate.datagrid_tMax')"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              data-field="tmin"
              :caption="$t('dataBaseClimate.datagrid_tMin')"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              data-field="hrmax"
              :caption="$t('dataBaseClimate.datagrid_HRmax')"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              data-field="hrmin"
              :caption="$t('dataBaseClimate.datagrid_HRmin')"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              data-field="rs"
              :caption="$t('dataBaseClimate.datagrid_Rs')"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              data-field="pluviometer"
              caption="Precipitación (mm)"
              :allow-header-filtering="false"
              alignment="left"
            />
            <DxColumn
              data-field="wind_spend"
              caption="Velocidad viento (m/s)"
              :allow-header-filtering="false"
              alignment="left"
            />
          </DxDataGrid>
        </DxScrollView>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxRequiredRule,
} from 'devextreme-vue/form';
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxSearchPanel,
  DxExport,
  DxColumnFixing,
  DxHeaderFilter,
  DxPager,
  DxSelection,
} from 'devextreme-vue/data-grid';
import { mapActions, mapState } from 'vuex';
import DxButton from 'devextreme-vue/button';
import moment from 'moment';
import { locale } from 'devextreme/localization';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import { DEVICE_PLATFORM, NUMBER_OF_DECIMALS, TO_FIXED_DECIMALS_IN_TABLES } from '../../../js/constants';

export default {
  name: 'ClimateOpenAir',
  components: {
    DxButton,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxRequiredRule,
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxSearchPanel,
    DxExport,
    DxColumnFixing,
    DxHeaderFilter,
    DxPager,
    DxSelection,
    DxScrollView,
  },
  data() {
    return {
      source: null,
      itemsClimate: [],
      dataSource: [],
      tableKey: 0,
      key: 0,
      checkBoxValue: false,
      NUMBER_OF_DECIMALS,
      TO_FIXED_DECIMALS_IN_TABLES,
      selectedDataType: 'MEAN_YEAR',
      selectedDataTypeShow: '',
      initDate: null,
      endDate: null,
    };
  },
  computed: {
    maxInitDate() {
      if (this.endDate) {
        if (this.endDate > new Date(Date.now())) {
          return new Date(Date.now());
        }
        return this.endDate;
      }
      const date = new Date();
      date.setDate(date.getDate() - 1);
      return date;
    },
    maxEndDate() {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      return date;
    },
    ...mapState('authentication', ['selection', 'profile']),
    ...mapState('ProjectOpenAir', ['stationClimate', 'climate', 'climateSource']),
    ...mapState('ProjectGreenHouse', ['provinces', 'province']),
  },
  created() {
    locale('es');
  },
  async mounted() {
    try {
      this.$f7.preloader.show();
      this.setDatabaseProvince(null);
      await this.fetchProvinces();
      await this.fetchDatabaseClimate();
      this.prepareList();
    } catch (error) {
      this.$f7.dialog.alert(this.$t(`${error}`));
    } finally {
      this.$f7.preloader.hide();
    }
  },
  methods: {
    async onChangeProvince(e) {
      if (typeof e.event !== 'undefined') {
        try {
          this.$f7.preloader.show();
          this.setDatabaseProvince(e.value);
          await this.fetchDatabaseClimate(e.value);
          this.prepareList();
        } catch (error) {
          this.$f7.dialog.alert(this.$t(`${error}`));
        } finally {
          this.$f7.preloader.hide();
        }
      }
    },
    prepareList() {
      const prepareItemsClimate = [];
      if (this.climate && this.climate.siar_stations
          && this.climate.siar_stations.data
          && this.climate.siar_stations.data.length) {
        this.climate.siar_stations.data.forEach((item) => {
          prepareItemsClimate.push({
            id: item.code,
            idByType: `${item.code}_MEAN_YEAR`,
            source: `${item.name} (Año medio)`,
            data_type: 'MEAN_YEAR',
          });
          prepareItemsClimate.push({
            id: item.code,
            idByType: `${item.code}_REAL_TIME`,
            source: item.name,
            data_type: 'REAL_TIME',
          });
        });
      }
      if (this.climate && this.climate.db_climate
          && this.climate.db_climate.length) {
        this.climate.db_climate.forEach((item) => {
          if (item.project_type === 'EX') {
            prepareItemsClimate.push({
              id: item.id,
              idByType: item.id,
              source: `${item.source} (Base de datos)`,
              data_type: 'DB',
            });
          }
        });
      }
      this.itemsClimate = prepareItemsClimate;
    },
    onChangeStationClimate(e) {
      if (typeof e.event !== 'undefined') {
        if (e.value === 'Añadir') {
          this.setEnabledPopUpStation(true);
        } else {
          const findItem = this.itemsClimate.find(((item) => item.idByType === e.value));
          if (findItem) {
            this.source = findItem.id;
            this.selectedDataType = findItem.data_type;
          }
        }
      }
    },
    onChangeInitDate(e) {
      if (typeof e.event !== 'undefined') {
        this.initDate = e.value;
      }
    },
    onChangeEndDate(e) {
      if (typeof e.event !== 'undefined') {
        this.endDate = e.value;
      }
    },
    async show() {
      try {
        this.$f7.preloader.show();
        if (this.source) {
          this.selectedDataTypeShow = this.selectedDataType;
          this.dataSource = [];
          if (this.climate && this.climate.mean_year === this.source) {
            await this.fetchDatabaseClimateSourceMeanYearEx();
          } else if (this.selectedDataType === 'DB') {
            await this.fetchDatabaseClimateSource(this.source);
          } else {
            const data = {
              source: this.source,
              init_date: this.selectedDataType === 'REAL_TIME'
                ? moment(this.initDate).format('YYYY-MM-DD') : null,
              end_date: this.selectedDataType === 'REAL_TIME'
                ? moment(this.endDate).format('YYYY-MM-DD') : null,
              data_type: this.selectedDataType,
            };
            await this.fetchDatabaseClimateSiar(data);
          }
          this.key += 1;
          if (this.climateSource && this.climateSource.parameters) {
            let params;
            if (this.selectedDataType === 'REAL_TIME' || this.selectedDataType === 'DB') {
              params = this.climateSource.parameters;
            } else {
              params = this.climateSource.parameters.parameters;
            }

            if (params && params.TEMPERATURE_MAX
                && params.TEMPERATURE_MAX.values
                && params.TEMPERATURE_MAX.values.length) {
              params.TEMPERATURE_MAX.values.forEach((item) => {
                this.dataSource.push({
                  yearoftheday: item.day,
                  tmax: Number(item.value.toFixed(this.NUMBER_OF_DECIMALS)),
                });
              });
            } else if (params && params.TEMPERATURE_MAX
                && params.TEMPERATURE_MAX['Temp Max (ºC)']
                && params.TEMPERATURE_MAX['Temp Max (ºC)'].length) {
              params.TEMPERATURE_MAX['Temp Max (ºC)'].forEach((item, i) => {
                this.dataSource.push({
                  date: Date.parse(item.date),
                  tmax: Number(item.value.toFixed(this.NUMBER_OF_DECIMALS)),
                });
              });
            }

            if (params && params.TEMPERATURE_MIN
                && params.TEMPERATURE_MIN.values
                && params.TEMPERATURE_MIN.values.length) {
              params.TEMPERATURE_MIN.values.forEach((item, index) => {
                try {
                  this.dataSource[index].tmin = Number(item.value.toFixed(this.NUMBER_OF_DECIMALS));
                } catch (e) {
                  console.log(e);
                }
              });
            } else if (params && params.TEMPERATURE_MIN
                && params.TEMPERATURE_MIN['Temp Mínima (ºC)']
                && params.TEMPERATURE_MIN['Temp Mínima (ºC)'].length) {
              params.TEMPERATURE_MIN['Temp Mínima (ºC)'].forEach((item, index) => {
                try {
                  this.dataSource[index].tmin = Number(item.value.toFixed(this.NUMBER_OF_DECIMALS));
                } catch (e) {
                  console.log(e);
                }
              });
            }

            if (params && params.SOLAR_RADIATION
                && params.SOLAR_RADIATION.values
                && params.SOLAR_RADIATION.values.length) {
              params.SOLAR_RADIATION.values.forEach((item, index) => {
                try {
                  this.dataSource[index].rs = Number(item.value.toFixed(this.NUMBER_OF_DECIMALS));
                } catch (e) {
                  console.log(e);
                }
              });
            } else if (params && params.SOLAR_RADIATION
                && params.SOLAR_RADIATION['Radiación (MJ/m2)']
                && params.SOLAR_RADIATION['Radiación (MJ/m2)'].length) {
              params.SOLAR_RADIATION['Radiación (MJ/m2)'].forEach((item, index) => {
                try {
                  this.dataSource[index].rs = Number(item.value.toFixed(this.NUMBER_OF_DECIMALS));
                } catch (e) {
                  console.log(e);
                }
              });
            }

            if (params && params.HUMIDITY_MAX
                && params.HUMIDITY_MAX.values
                && params.HUMIDITY_MAX.values.length) {
              params.HUMIDITY_MAX.values.forEach((item, index) => {
                try {
                  this.dataSource[index].hrmax = Number(
                    item.value.toFixed(this.NUMBER_OF_DECIMALS),
                  );
                } catch (e) {
                  console.log(e);
                }
              });
            } else if (params && params.HUMIDITY_MAX
                && params.HUMIDITY_MAX['Humedad Max (%)']
                && params.HUMIDITY_MAX['Humedad Max (%)'].length) {
              params.HUMIDITY_MAX['Humedad Max (%)'].forEach((item, index) => {
                try {
                  this.dataSource[index].hrmax = Number(
                    item.value.toFixed(this.NUMBER_OF_DECIMALS),
                  );
                } catch (e) {
                  console.log(e);
                }
              });
            }

            if (params && params.HUMIDITY_MIN
                && params.HUMIDITY_MIN.values
                && params.HUMIDITY_MIN.values.length) {
              params.HUMIDITY_MIN.values.forEach((item, index) => {
                try {
                  this.dataSource[index].hrmin = Number(
                    item.value.toFixed(this.NUMBER_OF_DECIMALS),
                  );
                } catch (e) {
                  console.log(e);
                }
              });
            } else if (params && params.HUMIDITY_MIN
                && params.HUMIDITY_MIN['Humedad Min (%)']
                && params.HUMIDITY_MIN['Humedad Min (%)'].length) {
              params.HUMIDITY_MIN['Humedad Min (%)'].forEach((item, index) => {
                try {
                  this.dataSource[index].hrmin = Number(
                    item.value.toFixed(this.NUMBER_OF_DECIMALS),
                  );
                } catch (e) {
                  console.log(e);
                }
              });
            }

            if (params && params.PRECIPITATION
                && params.PRECIPITATION.values
                && params.PRECIPITATION.values.length) {
              params.PRECIPITATION.values.forEach((item, index) => {
                try {
                  this.dataSource[index].pluviometer = Number(
                    item.value.toFixed(this.NUMBER_OF_DECIMALS),
                  );
                } catch (e) {
                  console.log(e);
                }
              });
            } else if (params && params.PLUVIOMETER
                && params.PLUVIOMETER['Precipitación (mm)']
                && params.PLUVIOMETER['Precipitación (mm)'].length) {
              params.PLUVIOMETER['Precipitación (mm)'].forEach((item, index) => {
                try {
                  this.dataSource[index].pluviometer = Number(
                    item.value.toFixed(this.NUMBER_OF_DECIMALS),
                  );
                } catch (e) {
                  console.log(e);
                }
              });
            }

            if (params && params.WIND_SPEED
                && params.WIND_SPEED.values
                && params.WIND_SPEED.values.length) {
              params.WIND_SPEED.values.forEach((item, index) => {
                try {
                  this.dataSource[index].wind_spend = Number(
                    item.value.toFixed(this.NUMBER_OF_DECIMALS),
                  );
                } catch (e) {
                  console.log(e);
                }
              });
            } else if (params && params.WIND_SPEED
                && params.WIND_SPEED['Velviento (m/s)']
                && params.WIND_SPEED['Velviento (m/s)'].length) {
              params.WIND_SPEED['Velviento (m/s)'].forEach((item, index) => {
                try {
                  this.dataSource[index].wind_spend = Number(
                    item.value.toFixed(this.NUMBER_OF_DECIMALS),
                  );
                } catch (e) {
                  console.log(e);
                }
              });
            }

            this.tableKey += 1;
          }
        }
      } catch (error) {
        this.$f7.dialog.alert('No se han podido obtener los datos climáticos');
      } finally {
        this.$f7.preloader.hide();
      }
    },
    onFileSaving(e) {
      if (DEVICE_PLATFORM === 'android') {
        cordova.plugins.saveDialog.saveFile(e.data, 'Base de Datos - LOCALIZACIÓN Y CLIMA - Aire Libre.xlsx').then((uri) => {
          console.info('The file has been successfully saved to', uri);
        }).catch((reason) => {
          console.warn(reason);
        });
      }
    },
    ...mapActions('ProjectGreenHouse', [
      'fetchProvinces', 'setDatabaseProvince', 'setEnabledPopUpStation',
    ]),
    ...mapActions('ProjectOpenAir', [
      'fetchDatabaseClimate', 'fetchDatabaseClimateSiar', 'fetchDatabaseClimateSourceMeanYearEx',
      'fetchDatabaseClimateSource',
    ]),
  },
};
</script>
<style lang="scss" scoped>
@import "../../../css/mixins";
  .boton-greenHouse {
    background: #FF7F26;
    height: 30px;
    width: 100px;
    margin-top: 60px;
    text-align: center;
  }
  .boton-openAir {
    .dx-button-mode-contained .dx-state-hover {
      background: #51A411 !important;
    }
    background: #51A411;
    height: 32px;
    width: auto;
    margin: 0 0.6rem 1rem;
    text-align: center;
    @include md {
      margin-top: 60px;
      max-width: 120px;
    }
  }
  .content-checkbox {
    padding-top: 50px;
    padding-left: 40px;
  }
</style>
